module.exports = __webpack_public_path__ + "static/media/191.fb600972.webp";